"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Given a base color hex will return a function that expects
 * some given opactiy and returns the base color at that
 * opacity.
 */
var _default = base => {
  const rgb = base?.match(/[^#]{2}/g)?.map(pair => parseInt(pair, 16));
  return opacity => `rgba(${rgb?.join(",")},${opacity})`;
};
exports.default = _default;